import { createRouter, createWebHashHistory } from "vue-router";
import { session } from "./network/session";
import type { GameInfo } from "./network/protocol";
import { hall } from "./network/hall-connection";
import { startBalanceStream } from "./network/balance-stream";
if (
  (!location.hash || location.hash === "#/") &&
  ["/", "/home", "/gameMingxing97", "/member", "/forget"].includes(
    location.pathname,
  ) &&
  location.pathname !== "/"
)
  history.replaceState(history.state, "", `/#${location.pathname}${location.search}`);
export const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      component: () => import("./authentication/LoginPage.vue"),
      meta: { public: true },
    },
    { path: "/login", redirect: "/" },
    {
      path: "/forget",
      component: () => import("./authentication/PasswordRecoveryPage.vue"),
      meta: { public: true },
    },
    {
      path: "/reg",
      component: () => import("./authentication/RegistrationPage.vue"),
      meta: { public: true },
    },
    { path: "/home", component: () => import("./lobby/LobbyPage.vue") },
    {
      path: "/chooseSeat",
      component: () => import("./machine-selection/ChooseSeatPage.vue"),
    },
    {
      path: "/gameMingxing97",
      component: () => import("./game-host/GameHostPage.vue"),
    },
    {
      path: "/member",
      component: () => import("./player-account/PlayerAccountPage.vue"),
    },
    {
      path: "/customerService",
      component: () => import("./player-account/CustomerServicePage.vue"),
    },
    {
      path: "/shopping",
      component: () => import("./shared/UnavailablePage.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      component: () => import("./shared/UnavailablePage.vue"),
    },
  ],
});
// Only a fresh room lookup may open a game connection. History entries and
// reload URLs contain old room data and must return to the list instead.
let pendingRoomPath = "";
export async function openGameRoom(room: GameInfo) {
  const target = {
    path: "/gameMingxing97",
    query: { mid: room.RoomId, sid: 1, item: JSON.stringify(room) },
  };
  pendingRoomPath = router.resolve(target).fullPath;
  try {
    // Push preserves the list for browser back; reentry after back replaces
    // the browser's forward branch rather than adding repeated game entries.
    await router.push(target);
  } finally {
    pendingRoomPath = "";
  }
}
router.beforeEach(async (to) => {
  if (to.meta.public) return;
  if (!session.token) return "/";
  if (to.path === "/gameMingxing97") {
    const approved = pendingRoomPath === to.fullPath;
    pendingRoomPath = "";
    if (!approved) return { path: "/home", replace: true };
  }
  if (!session.ready) {
    try {
      await hall.connect();
      startBalanceStream();
    } catch {
      if (!session.token) return "/";
    }
  }
});
